'use strict';

const i18n = require('i18next');
const Moment = require('moment');
const ActionAPI = require('process/infra/api/action/index');
const ActionFactory = require('process/domain/factory/action/index');
const ActionRepository = require('process/domain/repository/action/index');
const Snackbar = require('common/util/snackbar');

class Service {
    constructor(project, actionID, actionJSON, feedbackMessage) {
        this._project = project;
        this._actionID = actionID;
        this._actionJSON = actionJSON;
        this._feedbackMessage = feedbackMessage;
    }

    update() {
        if(!this._validate()) {
            return new Promise((resolve, reject) => {
                reject();
            });
        }
        return ActionAPI.update(
            this._project.id, this._actionID, this._actionJSON
        )
            .then(j => {
                const factory = new ActionFactory(this._project);
                const repo = ActionRepository.find(this._project);

                return factory.build(j, repo);
            })
            .then(_action => {
                const action = ActionRepository.find(this._project).add(_action);

                const msg = this._feedbackMessage
                    ? this._feedbackMessage
                    : i18n.t('process:feedback.update', {
                        name: action.getName()
                    });
                Snackbar.success(msg);

                return action
            });
    }

    _validate() {
        const startAt = this._actionJSON.startAt;
        const endAt = this._actionJSON.endAt;

        if(startAt && endAt) {
            if(Moment(endAt).diff(startAt) < 0) {
                Snackbar.error(
                    i18n.t('process:feedback.dateOrderError')
                );
                return false;
            }
        }

        return true;
    }
}

module.exports = Service;



// WEBPACK FOOTER //
// ./process/app/service/action/update.js